<script>
import { McWysiwyg } from '@mycure/vue-wysiwyg';
import pfMixin from '../../../../mixins/pfMixin'
import stepsMixin from '../../../../mixins/stepsMixin'

export default {
	mixins: [pfMixin,stepsMixin],
	components: {
		McWysiwyg,
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../PfModal'),
		PfLoader: () => import(/* webpackChunkName: "pf-loader" */ '../PfLoader'),
	},
	props: ['client', 'analysis', 'name'],

	data() {
		return {
			cliente: null,
			datos: {
				notas: ''
			},
			config: {
			events: {
				initialized: function () {
					console.log('initialized')
				}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},

	computed: {
		totalAccionistas() {
			let total = 0

			this.datos.principales_accionistas.forEach(a => {
				total += Number(a.porcentaje)
			})

			return total
		},
	},

	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
				if(!this.datos.fecha_constitucion) {
					this.$set(this.datos, 'fecha_constitucion', newData.datos.fecha_constitucion)
				}
				if(!this.datos.actividad_principal) {
					this.$set(this.datos, 'actividad_principal', newData.datos.actividad_principal)
				}
				if(!this.datos.cliente_desde) {
					this.$set(this.datos, 'cliente_desde', newData.datos.cliente_desde)
				}
				if(!this.datos.cuenta_clave) {
					this.$set(this.datos, 'cuenta_clave', newData.datos.cuenta_clave)
				}
				if(!this.datos.pais_cabecera) {
					this.$set(this.datos, 'pais_cabecera', newData.datos.pais_cabecera)
				}
				if(!this.datos.rfc) {
					this.$set(this.datos, 'rfc', newData.datos.rfc)
				}
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				debugger
				if(!newData.datos.fecha_constitucion) {
					delete newData.datos.fecha_constitucion
				}
				if(!newData.datos.actividad_principal) {
					delete newData.datos.actividad_principal
				}
				if(!newData.datos.cliente_desde) {
					delete newData.datos.cliente_desde
				}
				if(!newData.datos.cuenta_clave) {
					delete newData.datos.cuenta_clave
				}
				if(!newData.datos.pais_cabecera) {
					delete newData.datos.pais_cabecera
				}
				if(!newData.datos.rfc) {
					delete newData.datos.rfc
				}
				
				this.$set(this, 'datos', {...this.datos, ...newData.datos})
			},
			deep: true,
			immediate: true
		}
	},

	methods: {
		addShareholder() {
			this.datos.principales_accionistas.push({
				nombre: '',
				porcentaje: '',
			})
		},

		addFilial() {
			this.datos.principales_filiales.push({
				nombre: '',
				porcentaje: '',
				consolidacion: '',
				sector_actividad: '',
			})
		},

		removeShareholder(index) {
			this.datos.principales_accionistas.splice(index, 1)
		},

		removeFilial(index) {
			this.datos.principales_filiales.splice(index, 1)
		},

		
	}
}
</script>
<template>
	<div class="pb-5">
		<pf-modal ref="loaderModal" title="Espere">
			<div class="text-center p-2">
				<p>Realizando la operación seleccionada</p>
				<PfLoader />
			</div>
		</pf-modal>
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
		<div class="d-flex align-items-center py-3">
			<div class="d-flex align-items-center">
				<h4 class="m-0">Datos Básicos</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold ml-1"> <span class="icon-refresh"></span> Actualizar</button>
			</div>
			
		</div>

		<div id="accordion_db" class="pf-accordion  pb-3" >
			<div class="card">
				<div class="card-header p-1" id="db_h_1" data-v-step="pf_db_0">
					<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" data-target="#db_1" aria-expanded="true" aria-controls="db_1">
						Identificación
					</button>
				</div>

				<div id="db_1" class="collapse show" aria-labelledby="db_h_1" data-parent="#accordion_db">
					<div class="card-body">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-md-6 col-lg-5">
								<label class="pf-control" data-v-step="pf_db_1">
									<span class="pf-control__label">Nombre</span>
									<span class="pf-control__info">{{cliente.datos.nombre}}</span>
								</label>	
							</div>	
							<div class="col-12 col-md-6 col-lg-5 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Fecha de Constitución</span>
									<input type="number" class="pf-control__input pf-control--small px-1" v-model="datos.fecha_constitucion">
								</label>	
							</div>	
							<div class="col-12 col-md-6 col-lg-5">
								<label class="pf-control">
									<span class="pf-control__label">Actividad principal/Clave Banxico</span>
									<input class="pf-control__input pf-control--block" v-model="datos.actividad_principal">
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-5 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Cliente desde</span>
									<input type="number" class="pf-control__input pf-control--small px-1" v-model="datos.cliente_desde">
								</label>	
							</div>	
							<div class="col-12 col-md-6 col-lg-5">
								<label class="pf-control">
									<span class="pf-control__label">País Cabecera</span>
									<input class="pf-control__input pf-control--block" v-model="datos.pais_cabecera">
								</label>	
							</div>	
							<div class="col-12 col-md-6 col-lg-5 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Cta. Clave</span>
									<select class="pf-control__input" id="" v-model="datos.cuenta_clave">
										<option value="NO">NO</option>
										<option value="SI">SI</option>
									</select>
								</label>	
							</div>	
							<div class="col-12 col-md-6 col-lg-5">
								<label class="pf-control">
									<span class="pf-control__label">RFC</span>
									<input class="pf-control__input pf-control--block" v-model="datos.rfc">
								</label>	
							</div>	

							<div class="col-12 mx-auto" data-v-step="pf_db_2">
								<label class="pf-control d-flex">
									<span class="pf-control__label">Notas</span>
									<button class="pf-btn btn btn-primary btn-sm ml-3" data-v-step="pf_db_3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="datos.notas"
								@change="$parent.updatedForms"
								/>
							</div>	
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="db_h_2">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#db_2" aria-expanded="true" aria-controls="db_2" data-v-step="pf_db_4" @click="goToStep('pfDB',5)">
						Accionariado
					</button>
				</div>
				<div id="db_2" class="collapse" aria-labelledby="db_h_2" data-parent="#accordion_db">
					<div class="card-body">
						<div class="d-flex flex-wrap">
							<div class="col-12">
								<table class="table pf-table-odd  table-bordered" data-v-step="pf_db_5">
									<tbody>
										<tr>
											<th class="text-center" colspan="2">PRINCIPALES ACCIONISTAS</th>
											<th class="text-center">%</th>

											<th class="text-center">FECHA</th>
											<th class="text-center">¿ACCIONISTA DE CONTROL?</th>
											<th class="text-center">¿FINANCIAL SPONSOR?</th>											
										</tr>
										<tr v-for="(a, index) in datos.principales_accionistas" :key="`accionistas_${index}`">
											<td class="p-1">
												<button class="btn btn-light p-1 text-primary" @click="removeShareholder(index)" data-v-step="pf_db_6">
													<span class="icon-trash"></span>
												</button>
											</td>
											<td class="p-1">
												<input class="pf-control__input w-100" type="text" v-model="a.nombre">
											</td>
											<td class="p-1">
												<input class="pf-control__input pf-control--small" type="text" v-model="a.porcentaje">
											</td>
											<td class="p-1">
												<input class="pf-control__input w-100" type="date" v-model="a.fecha_de_entrada">
											</td>
											<td class="p-1">
												<input class="pf-control__input w-100" type="text" v-model="a.accionista_control">
											</td>
											<!-- <td class="p-1">
												<select name="" class="pf-control__input w-100" v-model="a.accionista_control">
													<option value="">--Seleccione--</option>
													<option value="SI">SI</option>
													<option value="NO">NO</option>
												</select>
											</td> -->
											<td class="p-1">
												<select name="" class="pf-control__input w-100" v-model="a.financial_sponsor">
													<option value="">--Seleccione--</option>
													<option value="SI">SI</option>
													<option value="NO">NO</option>
												</select>
											</td>
										</tr>
										<tr>
											<td class="p-1" colspan="2"></td>
											<td class="p-1">
												<input class="pf-control__input pf-control--small" type="text" v-model="totalAccionistas">
											</td>
											<td class="p-1" colspan="3"></td>
										</tr>
									</tbody>
								</table>
								<div>
									<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="addShareholder" data-v-step="pf_db_7"> <span class="icon-blank-page"></span> Nuevo Registro</button>
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-3 mt-5">
								<label class="pf-control" data-v-step="pf_db_8">
									<span class="pf-control__label">¿Cotiza en Bolsa?</span>
									<select class="pf-control__input pf-control--block" id="" v-model="datos.cotiza_en_bolsa">
										<option value="">--Seleccione--</option>
										<option value="NO">NO</option>
										<option value="SI">SI</option>
									</select>
								</label>	
							</div>
							<div class="col-12 mx-auto mt-5">
								<label class="pf-control d-flex">
									<span class="pf-control__label">Tipo de Administración / Conducta</span>
									<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="datos.tipo_administracion_conducta"
								/>
							</div>	
						</div>

					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="db_h_3">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#db_3" aria-expanded="true" aria-controls="db_3">
						Participaciones Significativas
					</button>
				</div>
				<div id="db_3" class="collapse" aria-labelledby="db_h_3" data-parent="#accordion_db">
				<div class="card-body">
					<div class="d-flex flex-wrap">
						<div class="col-12">
							<table class="table pf-table-odd  table-bordered">
								<tbody>
									<tr>
										<th class="text-center" colspan="2">PRINCIPALES FILIALES</th>
										<th class="text-center" style="width: 100px">%</th>
										<th class="text-center">CONSOLIDACIÓN</th>
										<th class="text-center">SECTOR ACTIVIDAD</th>
									</tr>
									<tr v-for="(a, index) in datos.principales_filiales" :key="`filiales_${index}`">
										<td class="p-1">
											<button class="btn btn-light p-1 text-primary" @click="removeFilial(index)">
												<span class="icon-trash"></span>
											</button>
										</td>
										<td class="p-1">
											<input class="pf-control__input w-100" type="text" v-model="a.nombre">
										</td>
										<td class="p-1">
											<input class="pf-control__input w-100" type="text" v-model="a.porcentaje">
										</td>
										<td class="p-1">
											<select name="" class="pf-control__input w-100" v-model="a.consolidacion">
												<option value="">--Seleccione--</option>
												<option value="Integración Global (IG)">Integración Global (IG)</option>
												<option value="Integración Proporcional (IP)">Integración Proporcional (IP)</option>
												<option value="Puesta en Equivalencia (PE)">Puesta en Equivalencia (PE)</option>
												<option value="No Consolida (No)">No Consolida (No)</option>
												<option value="N/D">N/D</option>
												<option value="Si">Si</option>
											</select>
										</td>
										<td class="p-1">
											<input class="pf-control__input w-100" type="text" v-model="a.sector_actividad">
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div>
							<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="addFilial"> <span class="icon-blank-page"></span> Nuevo Registro</button>
						</div>

						<div class="col-12 mx-auto mt-5">
								<label class="pf-control d-flex">
									<span class="pf-control__label">Notas</span>
									<button class="pf-btn btn btn-primary btn-sm ml-auto"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="datos.nota_principales_filiales"
								@change="$parent.updatedForms"
								/>
							</div>	
					</div>
				</div>
				</div>
			</div>
		</div>
		<div class="pf-controls-flow">
			<div class="container">
				<div class="d-flex">
					<div class="ml-auto pf-controls-flow__button">
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold"  @click="save()" data-v-step="pf_db_9"> <span class="icon-computer-folder"></span> Guardar</button>
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold ml-1"> <span class="icon-refresh"></span> Actualizar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>